import React from 'react'
import Row from '../../../../bootstrap/component/Row'
import Column from '../../../../bootstrap/component/Column'

const AlignerTreatmentMedical = ({anamnesis}) => {
    if (!anamnesis.formData) {
        return null
    }
    const keyList = Object.getOwnPropertyNames(anamnesis.formData)

    const renderValue = (key) => {
        const value = anamnesis.formData[key]
        if (value === undefined || value === null) {
            return ''
        }

        if (value === false) {
            return 'no'
        }

        if (value === true) {
            return 'yes'
        }

        if (value.join) {
            return value.map((answer, index) => {
                return <span key={index}>{answer}<br/></span>
            })
        }

        return value
    }

    return (
        <Row top="M">
            <Column size={12}>
                <table className="customer-form-table">
                    <thead>
                    <tr>
                        <th>Question</th>
                        <th>Answer</th>
                    </tr>
                    </thead>
                    <tbody>
                    {keyList.map(key => {
                        return (
                            <tr key={key}>
                                <td className="key">{key}</td>
                                <td className="value">{renderValue(key)}</td>
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
            </Column>
        </Row>
    )
}

export default AlignerTreatmentMedical



// WEBPACK FOOTER //
// ./src/modules/anamnesis/component/anamnesis/renderer/AlignerTreatmentMedical.js